import type { LocalizedRelease } from "../../types";

export const releases: Record<string, LocalizedRelease> = {
  "1.1.1": {
    title: "Stability pass",
    summary: "Fixes for canvas redraw flicker and a rare crash on wake from sleep.",
    highlights: [
      "Fixed flicker when redrawing the canvas after a fast zoom.",
      "Resolved a rare crash when waking the app from sleep.",
      "Lower idle CPU while the canvas sits in the background.",
    ],
  },
  "1.1.0": {
    title: "Faster canvas & agent groundwork",
    summary: "A rebuilt render path, a redesigned command palette, and the rails for agents.",
    highlights: [
      "Rebuilt render path keeps panning smooth with hundreds of windows.",
      "Redesigned command palette for jumping to any window, theme, or action.",
      "Groundwork for running long agent tasks directly on the canvas.",
      "Smaller memory footprint and a faster cold start.",
    ],
  },
  "1.0.2": {
    title: "Polish & fixes",
    summary: "Sharper text at high zoom and faster project switching.",
    highlights: [
      "Sharper text rendering at high zoom levels.",
      "Faster switching between recent projects.",
      "Assorted fixes to window focus and keyboard handling.",
    ],
  },
  "1.0.0": {
    title: "CATE 1.0",
    summary: "The first stable release: the canvas, terminals, editors, and browsers, shipping.",
    highlights: [
      "The infinite, zoomable canvas, stable and ready for daily work.",
      "Terminals, editors, and browsers as first-class windows.",
      "Persistent workspaces that restore exactly where you left off.",
      "macOS, Windows, and Linux builds.",
    ],
  },
  "0.9.3": {
    title: "Beta hardening",
    summary: "Memory fixes and a smaller install size ahead of 1.0.",
    highlights: [
      "Plugged several memory leaks found during the beta.",
      "Trimmed the install size noticeably.",
    ],
  },
  "0.9.0": {
    title: "Public beta",
    summary: "Open beta opens: multi-window canvases, persistence, and theming land.",
    highlights: [
      "Open beta: anyone can download and try CATE.",
      "Multi-window canvases with saved layouts.",
      "First pass at full-surface theming.",
    ],
  },
  "0.7.0": {
    title: "Themes arrive",
    summary: "The first built-in theme set, applied across the whole surface.",
    highlights: [
      "Built-in themes applied to the whole canvas, not just the editor.",
      "Instant light/dark switching with a keystroke.",
    ],
  },
  "0.4.0": {
    title: "Multi-pane canvas",
    summary: "Float more than one terminal or editor and arrange them spatially.",
    highlights: [
      "Open multiple terminals and editors at once.",
      "Drag windows freely to arrange them spatially.",
    ],
  },
  "0.1.0": {
    title: "First alpha",
    summary: "The earliest public build: one terminal on an infinite, zoomable plane.",
    highlights: [
      "One terminal on an infinite, zoomable plane.",
      "The seed of the whole idea.",
    ],
  },
};
